import http from "../http-common";

class InspectorService {
  createInspector(data) {
    return http.post("inspector/create", data);
  }
  updateInspector(data) {
    return http.post("inspector/update", data);
  }
  getInspectors(data) {
    return http.get("inspector/list", { params: data });
  }
  deleteInspector(data) {
    return http.delete("inspector/delete", { params: data });
  }
  getInspectorDetail(data) {
    return http.get("inspector/detail", { params: data });
  }
}

export default new InspectorService();